module.exports = __webpack_public_path__ + "img/10.69663fd6.jpg";